import React, { useEffect, useState } from 'react';

interface SuccessNotificationBannerProps {
  title?: string;
  content?: string;
  duration?: number;
  noScrollToTop?: boolean;
}

const SuccessNotificationBanner: React.FC<SuccessNotificationBannerProps> = ({
  title,
  content,
  duration,
  noScrollToTop,
}) => {
  const [isVisible, setIsVisible] = useState(true);

  // eslint-disable-next-line consistent-return
  useEffect(() => {
    if (typeof duration === 'number' && duration > 0) {
      const timer = setTimeout(() => {
        setIsVisible(false);
      }, duration);

      return () => clearTimeout(timer);
    }
  }, [duration]);

  useEffect(() => {
    if (isVisible && !noScrollToTop) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [isVisible, noScrollToTop]);

  if (!isVisible) return null; // If not visible, render nothing

  return (
    <div
      className="govuk-notification-banner govuk-notification-banner--success"
      role="alert"
      aria-labelledby="govuk-notification-banner-title"
      data-module="govuk-notification-banner"
    >
      <div className="govuk-notification-banner__header">
        <h2
          className="govuk-notification-banner__title"
          id="govuk-notification-banner-title"
        >
          Success
        </h2>
      </div>
      <div className="govuk-notification-banner__content">
        <h3 className="govuk-notification-banner__heading">{title}</h3>
        <p className="govuk-body">{content}</p>
      </div>
    </div>
  );
};

SuccessNotificationBanner.defaultProps = {
  title: '',
  content: '',
  duration: undefined,
  noScrollToTop: false,
};

export default SuccessNotificationBanner;
